module.exports = __webpack_public_path__ + "img/panel-register.c4123287.svg";